import { Injectable } from '@angular/core';
import { API_BASE_URL } from '@app/app.constants';
import { UnauthenticatedHttpClient } from '@app/auth/services/unauthenticated-http-client.service';
import { InitiateResetPasswordData } from '@app/core/interfaces/initiate-reset-password-data';
import { wrapError } from '@app/utils/rxjs';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ResetPasswordService {
  constructor(private unauthenticatedHttp: UnauthenticatedHttpClient) {}

  initiateResetPassword(loginName: string): Observable<InitiateResetPasswordData> {
    return this.unauthenticatedHttp
      .post<InitiateResetPasswordData>(`${API_BASE_URL}/forgotPassword`, {
        loginName,
      })
      .pipe(wrapError('initiate-reset-password'));
  }

  resetPassword(loginName: string, newPassword: string, token: string): Observable<void> {
    return this.unauthenticatedHttp
      .post<void>(`${API_BASE_URL}/resetPassword`, {
        loginName,
        newPassword,
        token,
      })
      .pipe(wrapError('reset-password'));
  }

  verifyToken(loginName: string, token: string): Observable<void> {
    return this.unauthenticatedHttp
      .post<void>(`${API_BASE_URL}/verifyToken`, {
        loginName,
        token,
      })
      .pipe(wrapError('verify-token'));
  }
}
